import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Image, Upload, message } from 'antd'
import {
    getAttachmentPreUrl,
    uploadAttachmentToAWS,
} from '../../../../../redux/testRun/testRun.service'

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
    })

const generateImageUrl = async (file) => {
    const { name = '' } = file ?? {}
    const formData = {
        filename: name,
        type: 'document',
    }

    const result = await getAttachmentPreUrl(formData)

    const { status, data } = result
    if (status === 'success') {
        const uploadURL = data?.presigned_url ?? ''
        const publicLink = data?.public_link ?? ''
        const response = await uploadAttachmentToAWS(uploadURL, file)

        if (response.status === 'success') {
            return publicLink
        }
        return ''
    }

    return ''
}

export default function Attachments(props) {
    const { fileList = [], setFileList = () => {} } = props
    // const [fileList, setFileList] = useState(propFileList)
    const [previewOpen, setPreviewOpen] = useState(false)
    const [previewImage, setPreviewImage] = useState('')

    const maxCount = 10

    const beforeUpload = (file) => {
        // optional checks
        const isAllowed =
            file.type.startsWith('image/') ||
            file.type === 'application/pdf' ||
            file.type ===
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            file.type === 'application/msword'
        if (!isAllowed) {
            message.error('Only images, PDF, and DOC/DOCX are allowed.')
            return Upload.LIST_IGNORE
        }
        // ❗ return false to stop auto upload
        return false
    }

    const handlePreview = async (file) => {
        if (
            !file.url &&
            !file.preview &&
            file.originFileObj &&
            file.type?.startsWith('image/')
        ) {
            file.preview = await getBase64(file.originFileObj)
        }
        // Only images can be previewed by <Image />
        if (file.type?.startsWith('image/')) {
            setPreviewImage(file.url || file.preview)
            setPreviewOpen(true)
        } else {
            message.info('Preview is available only for images.')
        }
    }

    const handleChange = ({ fileList: newList }) => setFileList(newList)

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    )

    return (
        <>
            <Upload
                listType="picture-card"
                fileList={fileList}
                name="files"
                maxCount={maxCount}
                multiple
                accept="image/*,.pdf,.doc,.docx"
                beforeUpload={beforeUpload} // 👈 stops network upload
                onPreview={handlePreview}
                onChange={handleChange}
            >
                {fileList.length >= maxCount ? null : uploadButton}
            </Upload>

            {previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (v) => setPreviewOpen(v),
                        afterOpenChange: (v) => !v && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </>
    )
}
